module.exports = __webpack_public_path__ + "static/media/don-3.4d17d6e4.png";